<template>
  <div class="template">
    <div class="nav clearfix navResize">
      <ul class="options">
        <li :class="{ active: active_idx_options == 0 }"
          style="posiotion:relative"
          @click="activeFn('active_idx_options', 0, '全部模版', 'all')">
          全部模版
          <ol class="template-ol" >
            <li v-for="(val, idx) in templateList"
              :key="idx"
              :class="{ activeTemplate: active_keys_idx == idx }"
              @click.stop="chnageTemplate(val, idx)">{{ val }}</li>
          </ol>
        </li>
        
        <li :class="{ active: active_idx_options == 1 }"
          @click="activeFn('active_idx_options', 1, '收藏模版', 'fav')">
          收藏模版
        </li>
        <li :class="{ active: active_idx_options == 2 }"
          @click="activeFn('active_idx_options', 2, '个人模版', 'my')">
          个人模版
        </li>
      </ul>
      <div class="other">
        <div class="search">
          <input type="text"
            class="searchBox"
            v-model="search_value"
            placeholder="输入关键字"
            @keyup.enter="submitFn" />
          <i class="cus-icon icon14"></i>
        </div>
        <ul class="ul-list">
          <li @click="changeTab(item, index)" :class="activeClass == index ? 'active' : ''" v-for="(item, index) in groupList">
            <i :class="item.icon"></i>
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="prompt" v-show="prompt_show">{{ prompt_value }}</div>
    <div class="list_box resultResize">
      <ul class="list_content">
        <li v-for="(item, key) in itemSet"
            :key="key">
          <img :src="item.src" />
          <div class="item_box">
            <div class="popup">
              <div v-if="active_idx_options ===0 || active_idx_options===1" class="show-btns">
                <div class="only-txt" v-if="item.is_favorite === 0">
                  <el-popover
                    popper-class="opreate-popover"
                    placement="top-start"
                    trigger="hover"
                    content="收藏">
                    <el-button @click="addCollect(item.id)" slot="reference" type="text" class="el-icon-star-off level-btn"></el-button>
                  </el-popover>
                </div>
                <div class="only-txt" v-else-if="item.is_favorite === 1">
                  <el-button type="text" class="el-icon-download download"></el-button>
                  <el-popover
                    popper-class="opreate-popover"
                    placement="top-start"
                    trigger="hover"
                    content="取消收藏">
                    <el-button @click="cancelCollect(item.id)" slot="reference" type="text" class="el-icon-star-on level-btn level-btn-on"></el-button>
                  </el-popover>
                </div>
              </div>
              <div class="only-txt" v-if="active_idx_options === 2">
                <el-button type="text" class="el-icon-download download"></el-button>
                <el-popover
                  popper-class="opreate-popover only-popover"
                  placement="top-start"
                  trigger="hover"
                  content="删除">
                  <el-button @click="deletesTemplate(item.id)" slot="reference" type="text" class="el-icon-delete level-btn level-btn-on"></el-button>
                </el-popover>
              </div>
              <div class="btn_preview border-div"
                @click="popPreviewFn(item.content)">
                预览
              </div>
              <div class="btn_splitUse border-div"
                @click="msg_click(item)">
                整套使用
              </div>
              <div class="btn_allUse border-div"
                @click="show_splitFn(key)">拆分使用</div>
            </div>
            <div class="item_text" style="padding-top:10px">{{ item.text }}</div>
            <p v-if="active_idx_options === 2" class="date-template item_text">更新于2019/3/10  12:10</p>
          </div>
        </li>
        <li class="load"
            :style="show_load"
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="busy"
            infinite-scroll-distance="0">
          <!-- <i class="el-icon-loading"></i> -->
        </li>
        <li class="over_moudle"
            v-show="waterfall_over">
          <div>已经到底了：）！</div>
        </li>
      </ul>
      <div v-show="nav_load" class="nav_load">
        <i class="el-icon-loading"></i>
      </div>
    </div>
    <com-splitpage v-on:add_ueditor_value="msg_click"
    v-on:hide="hide_splitFn"
    v-show="show_split"
    v-bind:itemSet="itemSet_split"></com-splitpage>
  </div>
</template>

<script>
import TemplateService from '@/service/api/templateService'
import comSplitpage from "../components/com-splitpage";

export default {
  name: "comTemplate",
  data() {
    return {
      condition: {
        tag: null,
        type: 'all',
        page: 0,
        order: 'rec',
      },
      nav_load: 1,
      busy: false,
      waterfall_over: 0,
      search_value: "",
      show_split: false,
      prompt_value: "搜索 “元宵节” 的结果：",
      prompt_show: false,
      active_idx_options: 0,
      active_idx_sort: 0,
      active_keys_idx: 0,
      activeClass: 0,
      itemSet: [],
      show_load: "visibility:visible",
      itemSet_split: [],
      scroll: true,
      groupList: [{
        name: '推荐',
        icon: 'iconfont icon-tuijian',
        id: 'rec'
      }, {
        name: '最热',
        icon: 'iconfont icon-zuire',
        id: 'hot'
      }, {
        name: '最新',
        icon: 'iconfont icon-zuixin',
        id: 'new'
      }],
      templateList: ['全部', '教育培训', '电子商务', '旅游出行', '行政政务', '餐饮美食', '商务办公', '酒店']
    };
  },
  methods: {
    //切换nav
    activeFn(name, idx, tag, type) {
      this[name] = idx;
      this.condition.type = type
      this.condition.page = 1;
      this.search_value = "";
      this.changData();
    },
    changeTab(obj, index) {
      this.activeClass = index
      this.condition.order = obj.id
      this.changData()
    },
    chnageTemplate(el, idx) {
      this.active_keys_idx = idx
      this.condition.tag = el === '全部' ? null : el
      this.changData()
    },
    //点击click
    msg_click(data) {
      this.$emit("add_ueditor_value", data);
    },
    //切换数据，数据节流加载
    changData() {
      this.nav_load = 1;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        document.querySelector(".list_box").scrollTop = 0;
        this.getTemplate();
      }, 500);
    },
    //show拆分
    show_splitFn(idx) {
      this.itemSet_split = [];
      Array.from(
        $("<div></div>")
          .html(this.itemSet[idx].content)
          .find(".ihuyiEditor")
      ).map(e => {
        this.itemSet_split.push($(e).html());
      });
      this.show_split = 1;
    },
    //hide拆分
    hide_splitFn() {
      this.show_split = 0;
    },
    //预览
    popPreviewFn(data) {
      this.$emit("pop_preview", data);
    },
    addCollect (id) {
      const templateSystem = new TemplateService()
      templateSystem.collectTemplate({tid: id})
        .then(() => {
          this.$notify.success('收藏成功')
          this.changData()
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    cancelCollect () {
      const templateSystem = new TemplateService()
      templateSystem.cancelTemplate({tid: id})
        .then(() => {
          this.$notify.success('已取消收藏')
          this.changData()
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    deletesTemplate (id) {
      const templateSystem = new TemplateService()
      templateSystem.delTemplates({tid: id})
        .then(() => {
          this.$notify.success('已删除模版')
          this.changData()
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    //下拉加载
    getTemplate(type) {
      this.waterfall_over = 0;
      this.prompt_show = false;
      const templateSystem = new TemplateService()
      templateSystem.templateLists(this.condition)
        .then(({ data }) => {
          if (data && data.data.length != 0) {
            if (type) {
              this.itemSet = [
                ...this.itemSet,
                ...data.data
              ]
            } else {
              this.itemSet = data.data;
            }
          } else if (this.condition.page == 1) {
            this.prompt_show = true;
            this.itemSet = [];
            this.prompt_value = `很抱歉，没有找到 “${
              this.condition.tag
            }” 相关的结果：`;
          }
          if (!data.data || data.data.length < 20) {
            this.waterfall_over = 1;
          } else {
            this.busy = false;
          }
          this.nav_load = 0;
          this.show_load = "visibility:hidden";
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    //下拉加载
    loadMore() {
      if (this.busy) return;
      this.show_load = "visibility:visible";
      this.busy = true;
      setTimeout(() => {
        this.condition.page++;
        this.getTemplate(1);
      }, 1000);
    },
    //站内搜索
    submitFn() {
      this.condition.page = 1;
      this.condition.tag = this.search_value;
      this.getTemplate();
    }
  },
  components: {
    comSplitpage
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/icon-font/iconfont.css';

.template {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  color: #535353;
  position: relative;

  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }
  .options li:first-child:hover{
    .template-ol{
      display: flex;
    } 
  }
  .options {
    min-width: 385px;
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    font-size: 14px;
    // justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .template-ol{
      position: absolute;
      display: none;
      top: 48px;
      z-index: 10000;
      left: 0;
      flex-wrap: wrap;
      background: #fff;
      padding-top: 10px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,.4);
      padding: 10px;
      padding-bottom: 0;
      margin-top: 2px;
      .activeTemplate{
        color: $color;
        border-color: $color;
      }
      li{
        width: auto;
        padding: 4px 10px;
        background: #fff;
        border: solid 1px #e5e5e5;
        border-radius: 3px;
        font-size: 13px;
        line-height: 1.2;
        margin-bottom: 10px;
        margin-right: 10px;
        color: #535353;
        &:hover{
          border-color: $color;
          color: $color;
          border-bottom: solid 1px $color;
        }
        
      }
      
    }
    .active {
      color: $color;
      font-weight: bold;
      background: #fff;
    }
    li {
      cursor: pointer;
      line-height: 48px;
      padding: 0 15px;
      // border-bottom: 2px solid transparent;
      background: #eee;
      width: 33%;
      margin-right: 2px;
      text-align: center;
      &:last-child{
        margin-right: 0;
      }
      &:hover {
        color: $color;
        border-bottom: 2px solid $color;
      }
    }
  }
  .other {
    float: left;
    min-width: 385px;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    float: left;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    .ul-list{
      display: flex;
      li{
        margin-right: 5px;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        i{
          margin-right: 5px;
        }
      }
      .activeClass{
        color: $color;
      }
    }
  }
  .active {
    color: $color;
    font-weight: bold;
  }
  .sort {
    display: flex;
    float: left;
    align-items: center;
    justify-content: space-between;

    li {
      margin-left: 10px;
    }
  }
  .searchBox {
    background-color: #f0f0f0;
    color: #a9aba8;
    font-size: 12px;
    border-radius: 15px;
    line-height: 25px;
    height: 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 30px 0 15px;
    width: 150px;
    border: none;
    &:hover + .icon14 {
      @extend .icon14_;
    }
  }
  .prompt {
    width: 330px;
    margin: auto;
    line-height: 40px;
    font-size: 13px;
    text-align: center;
    margin-top: 15px;
    background-color: rgba(204, 204, 204, 1);
  }

  .box_btn {
    width: 37px;
    position: absolute;
    top: 50%;
    right: -40px;
    z-index: 5;
    margin-top: -77px;
    display: flex;
    float: left;
    justify-content: space-between;
    div {
      width: 18px;
      height: 77px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .more {
      background-image: url(../assets/images/material_more.png);
    }
    .less {
      background-image: url(../assets/images/material_less.png);
    }
  }

  .list_box {
    width: 100%;
    position: absolute;
    top: 11%;
    bottom: 0;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .list_content {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    min-height: 100%;
    align-content: flex-start;
    // justify-content: space-between;
    padding: 10px 0;

    li {
      cursor: pointer;
      max-width: 49%;
      background-color: #fff;
      overflow: hidden;
      margin: 7px 0 8px 15px;
      width: 170px;
      box-sizing: border-box;
      border: 1px dotted #d9d9d9;
      position: relative;
      font-size: 14px;

      &:hover {
        border: 1px solid $color;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }

      .item_box {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        float: left;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .show-btns{
          width: 100%;
        }
        .only-txt{
          width: 90%;
          text-align: right;
          margin-top: -20px;
          margin-right: 10px;
          margin-bottom: 10px;
          .level-btn{
            color: #fa9101;
            font-size: 18px;
          }
          .download{
            color: #7b7b7b;
            background: #fff;
            padding: 5px;
            font-size: 18px;
          }
          .level-btn-on{
            &:hover{
              padding: 5px;
              background: #fa9101;
              color: #fff;
              opacity: 1;
            }
          }
        }
        &:hover .popup {
          opacity: 1;
        }
      }

      .popup {
        opacity: 0;
        width: 100%;
        height: 180px;
        display: flex;
        float: left;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.3);
        .border-div {
          width: 100px;
          height: 30px;
          border: 1px solid #ffffff;
          color: #7b7b7b;
          background: #fff;
          margin-top: 5px;
          border-radius: 5px;
          text-align: center;
          line-height: 30px;
          &:hover {
            border: 1px solid $color;
            background-color: $color;
            color: #fff;
          }
        }
        .icon4 {
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
      .date-template{
        padding: 8px 0;
      }
      .item_text {
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        background-color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .icon14 {
    position: absolute;
    top: 16px;
    left: 140px;
  }

  .list_content li.load {
    position: relative;
    width: 100%;
    display: flex;
    float: left;
    // height: 15px;
    margin: 0;
    justify-content: center;
    border: none;
    &:hover {
      border: none;
    }
    .el-icon-loading {
      position: absolute;
    }
  }
}
.bm_1 .list_content li {
  max-width: 24%;
}
</style>



// WEBPACK FOOTER //
// src/components/com-template.vue